var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3"},[_vm._v(" travel orders ")])
}
var staticRenderFns = []

export { render, staticRenderFns }